import React, { useState } from 'react';
import Icon from '../../../../../../../muiComponents/Icon';
import useTranslate from '../../../../../../../customHooks/useTranslate';
import {
    useZitoneoServices,
    useZitoneoServicesStats,
} from '../../../../../contexts/ZitoneoContentContext';
import IconButton from '../../../../../../../muiComponents/IconButton';

const ServicesWithActiveErratas = () => {
    const translate = useTranslate();
    const {
        handleVisibleServicesDetail,
        idVisibleServicesDetail,
        handleFocusHotelService,
    } = useZitoneoServices();
    const {
        servicesWithActiveExceptionsInCategory,
        selectedServicesInCategory,
        servicesInCategory,
    } = useZitoneoServicesStats();
    const [isDetailVisible, setIsDetailVisible] = useState(false);

    const serviceTypeCounters: Record<number, number> = {};
    const instanceNumberByHotelServiceId = servicesInCategory.reduce<
        Record<string, number>
    >((acc, service) => {
        serviceTypeCounters[service.IdServiceType] =
            (serviceTypeCounters[service.IdServiceType] || 0) + 1;
        acc[service.Id] = serviceTypeCounters[service.IdServiceType];

        return acc;
    }, {});

    if (!selectedServicesInCategory) {
        return null;
    }

    if (!servicesWithActiveExceptionsInCategory.length) {
        return (
            <li className='sidebar__quality_signal__item'>
                <div className='quality_signal__item__title'>
                    <Icon iconName='ErrorOutlineOutlined' />
                    <p>{translate('active_erratas_complete')}</p>
                </div>
            </li>
        );
    }

    return (
        <li className='sidebar__quality_signal__item --with-detail'>
            <div className='sidebar__quality_signal__item__header'>
                <div className='quality_signal__item__title'>
                    <Icon
                        iconName='ErrorOutlineOutlined'
                        className='quality_signal__item__icon'
                    />
                    <p>{translate('services_with_active_erratas')}</p>
                </div>
                <div className='flex flex-align-center'>
                    <div className='quality_signal__item__value --error'>
                        {servicesWithActiveExceptionsInCategory.length}
                    </div>
                    <IconButton
                        size='small'
                        iconName={
                            isDetailVisible ? 'ExpandMore' : 'ChevronRight'
                        }
                        onClick={() => setIsDetailVisible(!isDetailVisible)}
                    />
                </div>
            </div>
            {isDetailVisible ? (
                <ul className='sidebar__quality_signal__detail-list'>
                    {servicesWithActiveExceptionsInCategory.map(service => (
                        <li
                            key={service.Id}
                            className='sidebar__quality_signal__detail-list__item'
                            role='button'
                            tabIndex={0}
                            onClick={() => {
                                handleFocusHotelService(service.Id);
                                if (
                                    idVisibleServicesDetail !==
                                    service.IdServiceType
                                ) {
                                    handleVisibleServicesDetail(
                                        service.IdServiceType
                                    );
                                }
                            }}
                            onKeyDown={event => {
                                if (
                                    event.key === 'Enter' ||
                                    event.key === ' '
                                ) {
                                    event.preventDefault();
                                    handleFocusHotelService(service.Id);
                                    if (
                                        idVisibleServicesDetail !==
                                        service.IdServiceType
                                    ) {
                                        handleVisibleServicesDetail(
                                            service.IdServiceType
                                        );
                                    }
                                }
                            }}
                        >
                            <Icon
                                iconName='FiberManualRecord'
                                style={{
                                    color: '#cd6b0a',
                                    fontSize: '12px',
                                    flexShrink: 0,
                                    marginTop: '4px',
                                }}
                            />
                            <div>
                                <div className='sidebar__quality_signal__detail-list__title'>
                                    {service.ServiceType}
                                    {service.Name
                                        ? ` · ${service.Name}`
                                        : ` · #${
                                              instanceNumberByHotelServiceId[
                                                  service.Id
                                              ] || 1
                                          }`}
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            ) : null}
        </li>
    );
};

export default ServicesWithActiveErratas;
